import { CToastBody } from '@coreui/react';
import React from 'react';

const BaseToastBody = React.memo(({ children, ...rest }) => {
  return <CToastBody {...rest}>{children}</CToastBody>;
});

export default BaseToastBody;
